import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const QuoteActions = ({ 
  onApprove, 
  onReject, 
  isLoading, 
  showSignature = false,
  onShowSignature 
}) => {
  const [showRejectForm, setShowRejectForm] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [rejectError, setRejectError] = useState('');

  const handleApprove = () => {
    if (onShowSignature) {
      onShowSignature();
    } else {
      onApprove();
    }
  };

  const handleReject = () => {
    if (!rejectReason?.trim()) {
      setRejectError('Veuillez indiquer la raison du refus');
      return;
    }

    onReject({
      reason: rejectReason?.trim(),
      timestamp: new Date()?.toISOString()
    });
  };

  const handleRejectReasonChange = (e) => {
    setRejectReason(e?.target?.value);
    if (rejectError) setRejectError('');
  };

  if (isLoading) {
    return (
      <div className="bg-surface border border-border rounded-lg p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/3 mb-4"></div>
          <div className="flex space-x-4">
            <div className="h-12 bg-muted rounded flex-1"></div>
            <div className="h-12 bg-muted rounded flex-1"></div>
          </div>
        </div>
      </div>
    );
  }

  if (showRejectForm) {
    return (
      <div className="bg-surface border border-border rounded-lg p-6 shadow-soft">
        <h2 className="text-lg font-semibold text-text-primary mb-4 flex items-center space-x-2">
          <Icon name="XCircle" size={20} className="text-error" />
          <span>Refuser le Devis</span>
        </h2>

        <div className="space-y-4">
          <Input
            label="Raison du refus"
            type="textarea"
            placeholder="Veuillez expliquer pourquoi vous refusez ce devis (optionnel mais recommandé)"
            value={rejectReason}
            onChange={handleRejectReasonChange}
            error={rejectError}
            rows={4}
          />

          <div className="flex space-x-3">
            <Button
              variant="outline"
              iconName="ArrowLeft"
              iconPosition="left"
              onClick={() => {
                setShowRejectForm(false);
                setRejectReason('');
                setRejectError('');
              }}
              className="flex-1"
            >
              Retour
            </Button>
            <Button
              variant="destructive"
              iconName="XCircle"
              iconPosition="left"
              onClick={handleReject}
              className="flex-1"
            >
              Confirmer le Refus
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface border border-border rounded-lg p-6 shadow-soft">
      <h2 className="text-lg font-semibold text-text-primary mb-4 flex items-center space-x-2">
        <Icon name="CheckSquare" size={20} />
        <span>Décision sur le Devis</span>
      </h2>

      <div className="space-y-4">
        <p className="text-text-secondary text-sm">
          Veuillez examiner attentivement tous les détails du devis ci-dessus avant de prendre votre décision. 
          Une fois votre choix confirmé, une notification sera automatiquement envoyée au professionnel.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Button
            variant="success"
            size="lg"
            iconName="CheckCircle"
            iconPosition="left"
            onClick={handleApprove}
            fullWidth
            className="h-16 text-base"
          >
            <div className="text-center">
              <div className="font-semibold">Approuver le Devis</div>
              <div className="text-xs opacity-90 mt-1">
                {showSignature ? 'Procéder à la signature' : 'Accepter et signer'}
              </div>
            </div>
          </Button>

          <Button
            variant="destructive"
            size="lg"
            iconName="XCircle"
            iconPosition="left"
            onClick={() => setShowRejectForm(true)}
            fullWidth
            className="h-16 text-base"
          >
            <div className="text-center">
              <div className="font-semibold">Refuser le Devis</div>
              <div className="text-xs opacity-90 mt-1">
                Décliner cette proposition
              </div>
            </div>
          </Button>
        </div>

        <div className="flex items-center justify-center space-x-2 text-xs text-text-secondary mt-6">
          <Icon name="Clock" size={14} />
          <span>Ce devis est valable jusqu'au 15/01/2025</span>
        </div>
      </div>
    </div>
  );
};

export default QuoteActions;